// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__Xfr5x","opacity-transition":"success_opacity-transition__bCNrt"};